import {Component, OnInit} from '@angular/core';
import {faCalendarAlt} from '@fortawesome/free-regular-svg-icons';
import {
  NgbActiveModal, NgbDate, NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap';

import {AppointmentRequest} from '../../../services/rest-api.service';
import {CustomNgbDateParserFormatter} from "./custom-ngb-date-parser-formatter";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct";
import {format} from "date-fns";

@Component({
  selector: 'app-appointment-create',
  templateUrl: './appointment-create.component.html',
  providers: [{provide: NgbDateParserFormatter, useClass: CustomNgbDateParserFormatter}]
})
export class AppointmentCreateComponent implements OnInit {
  faCalendarAlt = faCalendarAlt;
  appointmentRequest: AppointmentRequest = {
    message: '',
    location: '',
    staffMember: '',
    appointmentDate: '',
    appointmentTime: 'anytime',
    appointmentId: 0,
    requestType: '',
    displayedAppointmentDate: ''
  };
  minDate: NgbDate;
  dateModel: NgbDateStruct | string | undefined;
  dateErrorMessage: string | null = null;

  constructor(
    public modal: NgbActiveModal
  ) {
  }

  ngOnInit(): void {
    const current = new Date();
    this.minDate = new NgbDate(current.getFullYear(),
      current.getMonth() + 1,
      current.getDate());
  }

  submit(): void {
    if (!this.dateModel) {
      this.dateErrorMessage = 'Date is required';
      return;
    }
    if (typeof this.dateModel === "string") {
      this.dateErrorMessage = 'Enter date as mm/dd/yyyy or mm-dd-yyyy';
      return;
    }
    if (NgbDate.from(this.dateModel).before(this.minDate)) {
      this.dateErrorMessage = 'Request must be for today or later';
      return;
    }
    // Format the dateModel/NgbDate into the string expected by the persistence tier (yyyy-MM-dd).
    const appointmentDate = CustomNgbDateParserFormatter.dateFromNgbDateStruct(this.dateModel);
    this.appointmentRequest.appointmentDate = format(appointmentDate, 'yyyy-MM-dd');
    this.appointmentRequest.requestType = 'new_appointment';
    this.modal.close(this.appointmentRequest);
  }
}
